import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ColoredOverlayWindow from 'src/legacy/Components/Windows/ColoredOverlayWindow';

import { useEventData } from '../hooks';
import {
  useCartStore,
  useCheckoutFormValuesStore,
  useCheckoutStore,
} from '../stores';

const CheckoutError = () => {
  const { eventID } = useParams();
  const navigate = useNavigate();

  const event = useEventData();
  const { reinitializeEventCart } = useCartStore();
  const { clearEventCheckout } = useCheckoutStore();
  const { clearFormValues } = useCheckoutFormValuesStore();

  const goToPage = () => {
    navigate('/me/tickets');
  };


  React.useEffect(() => {
    reinitializeEventCart(eventID!, event?.ticketTypes);
  }, [event?.ticketTypes, eventID, reinitializeEventCart]);

  React.useEffect(() => {
    clearEventCheckout(eventID!);
  }, [clearEventCheckout, eventID]);

  React.useEffect(() => {
    clearFormValues();
  }, [clearFormValues]);

  return (
    <ColoredOverlayWindow
      show={true}
      title="Falha ao consultar o status do seu pagamento"
      requestStatus="generic"
      {...{ goToPage }}
      buttonText={undefined}>
      Confira em 'Meus ingressos' se o seu pagamento foi aprovado. Caso não
      tenha sido, aguarde algumas horas e você deve receber um email. Se não
      receber o email entre em contato conosco.
    </ColoredOverlayWindow>
  );
};

export default CheckoutError;
